import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ReagentVerificationDrawer from "./modules/ReagentVerificationDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { getBindingValue, getLargePermission } from '@/utils/hasPermission';
import { deleteAction } from '@api/manage';
export default {
  name: 'ReagentVerificationList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    ReagentVerificationDrawer: ReagentVerificationDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/reagent/verification',
      pageTitle: '标液核查',
      addDisabled: false,
      userTree: [],
      //人员信息
      // 表头
      isorter: {
        column: 'verification_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'verificationDate',
        colName: 'verification_date',
        title: '核查时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '核查类型',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      st: ''
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    },
    currentSiteType: function currentSiteType(newVal) {
      this.st = newVal;
    }
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryParam.status = 1;
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateVerificationDate: function onDateVerificationDate(value, dateArray) {
      this.queryParam.verificationDateStart = dateArray[0];
      this.queryParam.verificationDateEnd = dateArray[1];
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleDelete: function handleDelete(id) {
      // if (!this.url.delete) {
      //   this.$message.error('请设置url.delete属性!')
      //   return
      // }
      var that = this;
      var headers = {};

      if (that.permissionObj.delete) {
        headers = {
          id: id,
          tableName: that.permissionObj.delete.split(':')[1]
        };
        var largePermission = getLargePermission({
          value: that.permissionObj.delete
        });
        getBindingValue(headers, largePermission);
      }

      deleteAction(that.url && that.url.delete ? that.url.delete : this.pagePath, {
        id: id,
        st: this.st
      }, headers).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          }); //this.queryParam = {}

          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};